<div class="mt-6">
  <!--Si hay idPropuestaEditar, mostramos el detalle/edición-->
  @if (idPropuestaEditar) {
    <app-detalle-propuesta-comercial
      [idPropuesta]="idPropuestaEditar"
      (onClose)="onDetalleClose($event)"
    />
  } @else if (idContacto) {
  <!--Si hay idContacto significa que se viene desde el botón de generar propuesta, por lo que se muestra el formulario-->
    <app-card [title]="'Crear propuesta comercial'">
      <div class="mb-3">
        <label
          for="path"
          class="shadow-theme-xs group hover:border-brand-500 block cursor-pointer rounded-lg border-2 border-dashed bg-gray-50 border-gray-300 transition dark:hover:border-brand-400 dark:border-gray-700 dark:bg-gray-900"
        >
          <div class="flex justify-center p-10">
            <div class="flex flex-col items-center">
              <div class="inline-flex h-13 w-13 mb-3 items-center justify-center rounded-full bg-gray-200 text-gray-700  transition dark:bg-gray-800 dark:text-gray-400">
                <mat-icon>file_upload</mat-icon>
              </div>

              <h4 class="font-semibold text-gray-800 text-theme-xl dark:text-white/90">
                Haga clic para subir archivo
              </h4>

              <span class="font-medium underline text-theme-sm text-brand-500">
                Examinar archivo
              </span>
            </div>
          </div>
          <input type="file" id="path" #fileInput class="hidden" accept=".pdf,application/pdf" (change)="onFileSelected($event)" />
        </label>

        @if (fileSelected) {
          <div class="flex justify-center items-center mt-4">
            <div class="relative overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm min-w-36 max-w-36 dark:border-gray-800 dark:bg-white/[0.03]">
              <div class="flex flex-col items-center">
                <mat-icon class="px-3 py-5 text-6xl! w-auto! h-auto! text-gray-700! dark:text-gray-400!">insert_drive_file</mat-icon>
                <div class="flex flex-col p-3 w-full bg-gray-100 dark:bg-white/[0.05]">
                  <small class="truncate text-gray-700 dark:text-gray-400" [matTooltip]="fileSelected.name">{{fileSelected.name}}</small>
                </div>
              </div>
              <button
                class="absolute! top-1 right-1"
                mat-icon-button
                (click)="clearFileInput()"
              >
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>
        }
      </div>

      <div class="grid grid-cols-1 gap-3 md:grid-cols-2 mb-3">
        <div>
          <app-label>Numero de presupuesto</app-label>
          <app-input-field id="presupuesto_nro" type="text" [(ngModel)]="presupuestoNro" />
        </div>

        <div>
          <app-label>Fecha de generacion</app-label>
          <app-input-field id="fecha_generacion" type="date" [(ngModel)]="fechaGeneracion" />
        </div>

        <div>
          <app-label>Fecha de envio</app-label>
          <app-input-field id="fecha_envio" type="date" [(ngModel)]="fechaEnvio" />
        </div>

        <div>
          <app-label>Estado</app-label>
          <app-select id="estado" [(ngModel)]="estado" [options]="estadoCrearOptions" />
        </div>

        <div>
          <app-label>Monto</app-label>
          <app-input-field id="monto" type="number" [(ngModel)]="monto" />
        </div>

        <div>
          <app-label>Descuento</app-label>
          <app-input-field id="descuento" type="number" [(ngModel)]="descuento" />
        </div>
      </div>

      <div>
        <app-label>Descripcion</app-label>
        <app-textarea id="descripcion" [(ngModel)]="descripcion" [rows]="4" />
      </div>
    </app-card>

    <app-creation-buttons *hasPermission="'prospectos:create'"
      [process]="process"
      [valid]="true"
      (onCancelClick)="resetForm()"
      (onCreateClick)="create()"
    />
  } @else {
    <!--Si no hay id, mostramos el listado-->
    <app-page-header
      [pageTitle]="'Listado de propuestas comerciales'"
      [showCreateButton]="permissionAuth.canCreate('prospectos')"
      [textButton]="'Nueva propuesta'"
      (onCreateClick)="openSeleccionarContacto()"
    />

    <app-filters-container
      [hasData]="propuestas.length > 0"
      [hasActiveFilters]="hasActiveFilters"
      [loading]="loading"
      (clearFilters)="clearFilters()"
    >
      <app-search-input
        label="Buscar"
        [value]="filtros.busqueda"
        placeholder="Descripcion, presupuesto, motivo..."
        containerClass="flex-1 min-w-80"
        (searchChange)="onSearchChange($event)"
      />

      <app-filter-select
        label="Estado"
        [value]="filtros.estado"
        [options]="estadoOptions"
        (valueChange)="onEstadoChange($event)"
      />

      <app-filter-select
        label="Activo"
        [value]="filtros.activo"
        [options]="activoOptions"
        (valueChange)="onActivoChange($event)"
      />

      <app-filter-date
        label="Fecha generacion desde"
        [value]="filtros.fecha_desde"
        (valueChange)="onFechaDesdeChange($event)"
      />

      <app-filter-date
        label="Fecha generacion hasta"
        [value]="filtros.fecha_hasta"
        (valueChange)="onFechaHastaChange($event)"
      />

      <app-filter-date
        label="Fecha envio desde"
        [value]="filtros.fecha_envio_desde"
        (valueChange)="onFechaEnvioDesdeChange($event)"
      />

      <app-filter-date
        label="Fecha envio hasta"
        [value]="filtros.fecha_envio_hasta"
        (valueChange)="onFechaEnvioHastaChange($event)"
      />

      <app-filter-date
        label="Fecha contacto desde"
        [value]="filtros.fecha_contacto_desde"
        (valueChange)="onFechaContactoDesdeChange($event)"
      />

      <app-filter-date
        label="Fecha contacto hasta"
        [value]="filtros.fecha_contacto_hasta"
        (valueChange)="onFechaContactoHastaChange($event)"
      />
    </app-filters-container>

    <app-data-table
      [columns]="columns"
      [data]="propuestas"
      [loading]="loading"
      [emptyTitle]="'No hay propuestas comerciales registradas'"
      [emptySubtitle]="'Prueba ajustando los filtros o crea una nueva propuesta'"
      (rowClick)="onRowClick($event)"
    >
      <ng-template appTableCell="presupuesto" let-propuesta>
        <div class="flex flex-col">
          @if (propuesta.presupuesto_nro) {
            <span>{{ propuesta.presupuesto_nro }}</span>
          } @else {
            <span class="text-gray-400 dark:text-gray-500">Sin numero</span>
          }
          @if (propuesta.confirmacion_recepcion) {
            <small class="text-gray-500 dark:text-gray-400">Recepcion confirmada</small>
          } @else {
            <small class="text-gray-500 dark:text-gray-400">Recepcion pendiente</small>
          }
        </div>
      </ng-template>

      <ng-template appTableCell="contacto_fecha" let-propuesta>
        @if (propuesta.contacto_fecha) {
          <span>{{ propuesta.contacto_fecha | date: 'dd/MM/yyyy' }}</span>
        } @else {
          <span class="text-gray-400 dark:text-gray-500">-</span>
        }
      </ng-template>

      <ng-template appTableCell="fechas" let-propuesta>
        <div class="flex flex-col">
          <span>Generacion: {{ propuesta.fecha_generacion_presupuesto | date: 'dd/MM/yyyy' }}</span>
          @if (propuesta.fecha_envio_presupuesto) {
            <small class="text-gray-500 dark:text-gray-400">Envio: {{ propuesta.fecha_envio_presupuesto | date: 'dd/MM/yyyy' }}</small>
          }
          @if (propuesta.fecha_confirmacion_recepcion) {
            <small class="text-gray-500 dark:text-gray-400">Confirmacion: {{ propuesta.fecha_confirmacion_recepcion | date: 'dd/MM/yyyy' }}</small>
          }
        </div>
      </ng-template>

      <ng-template appTableCell="monto" let-propuesta>
        <div class="flex flex-col">
          @if (propuesta.monto) {
            <span>{{ propuesta.monto }}</span>
          } @else {
            <span class="text-gray-400 dark:text-gray-500">Sin monto</span>
          }
          @if (propuesta.descuento) {
            <small class="text-gray-500 dark:text-gray-400">Desc: {{ propuesta.descuento }}</small>
          }
        </div>
      </ng-template>

      <ng-template appTableCell="estado" let-propuesta>
        @if (propuesta.estado === 'pendiente') {
          <app-badge [color]="'warning'" [startIcon]="'schedule'">Pendiente</app-badge>
        } @else if (propuesta.estado === 'aceptada') {
          <app-badge [color]="'success'" [startIcon]="'check_circle'">Aceptada</app-badge>
        } @else if (propuesta.estado === 'rechazada') {
          <div class="flex flex-col gap-1">
            <app-badge [color]="'error'" [startIcon]="'cancel'">Rechazada</app-badge>
            @if (propuesta.motivo_rechazo) {
              <small class="text-gray-500 dark:text-gray-400">Motivo: {{ propuesta.motivo_rechazo }}</small>
            }
          </div>
        }
      </ng-template>

      <ng-template appTableCell="descripcion" let-propuesta>
        @if (propuesta.descripcion) {
          <span class="line-clamp-2">{{ propuesta.descripcion }}</span>
        } @else {
          <span class="text-gray-400 dark:text-gray-500">Sin descripcion</span>
        }
      </ng-template>

      <ng-template appTableCell="activo" let-propuesta>
        @if (propuesta.activo) {
          <app-badge [color]="'success'">Activa</app-badge>
        } @else {
          <app-badge [color]="'error'">Inactiva</app-badge>
        }
      </ng-template>

      <ng-template appTableCell="acciones" let-propuesta let-index="index">
        <div class="flex items-center gap-x-2">
          <button
            class="hover:text-brand-500 hover:dark:text-brand-400 dark:text-gray-400 disabled:text-brand-300 disabled:cursor-not-allowed"
            [disabled]="downloading && (downloadingIndex === index)"
            [matTooltip]="'Descargar'"
            (click)="download(propuesta.id, index); $event.stopPropagation()"
          >
            <mat-icon>download</mat-icon>
          </button>

          <button
            class="hover:text-brand-500 hover:dark:text-brand-400 dark:text-gray-400 disabled:text-brand-300 disabled:cursor-not-allowed"
            [matTooltip]="'Editar'"
            (click)="edit(propuesta.id); $event.stopPropagation()"
          >
            <mat-icon>edit</mat-icon>
          </button>

          <!-- <app-delete-trigger *hasPermission="'prospectos:delete'"
            [title]="'Eliminar propuesta comercial'"
            [disabled]="deleting && (deletingIndex === index)"
            (clickDeleteEvent)="delete(propuesta.id, index); $event.stopPropagation()"
          /> -->
        </div>
      </ng-template>
    </app-data-table>

    <app-pagination
      [currentPage]="currentPage"
      [lastPage]="lastPage"
      [perPage]="perPage"
      [total]="total"
      (pageChange)="onPageChange($event)"
      (perPageChange)="onPerPageChange($event)"
    />
  }
</div>
